module.exports = __webpack_public_path__ + "img/qr.b29344e3.jpg";